export const thunkTypes = {
  LIST_PENDING: `pendingConfirmation/listPending`,
  LIST_ZONES: `pendingConfirmation/listZones`,
  LIST_GEO_CATALOG: `pendingConfirmation/listGeoCatalog`,
  UPDATE_ADDRESS: `pendingConfirmation/updateAddress`,
  ADD_ADDRESS: `pendingConfirmation/addAddress`,
  CONFIRM: `pendingConfirmation/confirm`,
  LIST_CONTACT_LOGS: `pendingConfirmation/listContactLogs`,
  LOG_CONTACT: `pendingConfirmation/logContact`,
};
